"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMINDER_TYPE = exports.SOCKET_BODY_EMOJI = exports.FILE_TYPE = exports.ACCEPTED_FILE_TYPES = exports.ACCEPTED_FILE_TYPES_WITHOUT_AUDIO_VIDEO = exports.UPLOAD_CONFIG = exports.FILE_CONSTANTS = exports.EDIT_MESSAGE_STATUS = exports.MESSAGE_STATUS = exports.MESSAGE_CONTENT_DOCUMENT_TYPE = exports.MESSAGE_CONTENT_MEDIA_TYPE = exports.MESSAGE_SENDER_TYPE = exports.MESSAGE_CONTENT_TYPE = exports.MESSAGE_TYPE = exports.ACTION_STATUS = exports.AVAILABLE_ACTIONS = exports.ACTIONS_VISIBLE_TO = void 0;
var ACTIONS_VISIBLE_TO;
(function (ACTIONS_VISIBLE_TO) {
    ACTIONS_VISIBLE_TO["ADMIN"] = "ADMIN";
    ACTIONS_VISIBLE_TO["STAFF"] = "STAFF";
})(ACTIONS_VISIBLE_TO || (exports.ACTIONS_VISIBLE_TO = ACTIONS_VISIBLE_TO = {}));
var AVAILABLE_ACTIONS;
(function (AVAILABLE_ACTIONS) {
    AVAILABLE_ACTIONS["REVOKE"] = "REVOKE";
    AVAILABLE_ACTIONS["REMIND_AGAIN"] = "REMIND_AGAIN";
})(AVAILABLE_ACTIONS || (exports.AVAILABLE_ACTIONS = AVAILABLE_ACTIONS = {}));
var ACTION_STATUS;
(function (ACTION_STATUS) {
    ACTION_STATUS["EXECUTED"] = "EXECUTED";
    ACTION_STATUS["ACTIVE"] = "ACTIVE";
})(ACTION_STATUS || (exports.ACTION_STATUS = ACTION_STATUS = {}));
var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["NORMAL"] = "NORMAL";
    MESSAGE_TYPE["REMINDER"] = "REMINDER";
    MESSAGE_TYPE["PRIORITY"] = "PRIORITY";
    MESSAGE_TYPE["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    MESSAGE_TYPE["ACKNOWLEDGE"] = "ACKNOWLEDGE";
    MESSAGE_TYPE["INFO"] = "INFO";
    MESSAGE_TYPE["REPLY"] = "REPLY";
    MESSAGE_TYPE["SUGGESTED_USERS_TO_ADD"] = "SUGGESTED_USERS_TO_ADD";
})(MESSAGE_TYPE || (exports.MESSAGE_TYPE = MESSAGE_TYPE = {}));
var MESSAGE_CONTENT_TYPE;
(function (MESSAGE_CONTENT_TYPE) {
    MESSAGE_CONTENT_TYPE["TEXT"] = "TEXT";
    MESSAGE_CONTENT_TYPE["DOCUMENT"] = "DOCUMENT";
    MESSAGE_CONTENT_TYPE["REMINDER"] = "REMINDER";
    MESSAGE_CONTENT_TYPE["IMAGE"] = "IMAGE";
    MESSAGE_CONTENT_TYPE["VIDEO"] = "VIDEO";
    MESSAGE_CONTENT_TYPE["LINK"] = "LINK";
    MESSAGE_CONTENT_TYPE["VOICE"] = "VOICE";
    MESSAGE_CONTENT_TYPE["FORM"] = "FORM";
    MESSAGE_CONTENT_TYPE["SMART"] = "SMART";
    MESSAGE_CONTENT_TYPE["LOCATION"] = "LOCATION";
})(MESSAGE_CONTENT_TYPE || (exports.MESSAGE_CONTENT_TYPE = MESSAGE_CONTENT_TYPE = {}));
var MESSAGE_SENDER_TYPE;
(function (MESSAGE_SENDER_TYPE) {
    MESSAGE_SENDER_TYPE["APP"] = "APP";
    MESSAGE_SENDER_TYPE["USER"] = "USER";
})(MESSAGE_SENDER_TYPE || (exports.MESSAGE_SENDER_TYPE = MESSAGE_SENDER_TYPE = {}));
exports.MESSAGE_CONTENT_MEDIA_TYPE = [
    MESSAGE_CONTENT_TYPE.IMAGE,
    MESSAGE_CONTENT_TYPE.VOICE,
    MESSAGE_CONTENT_TYPE.VIDEO,
];
var MESSAGE_CONTENT_DOCUMENT_TYPE;
(function (MESSAGE_CONTENT_DOCUMENT_TYPE) {
    MESSAGE_CONTENT_DOCUMENT_TYPE["PDF"] = "PDF";
    MESSAGE_CONTENT_DOCUMENT_TYPE["XLS"] = "XLS";
    MESSAGE_CONTENT_DOCUMENT_TYPE["XLSX"] = "XLSX";
    MESSAGE_CONTENT_DOCUMENT_TYPE["DOC"] = "DOC";
})(MESSAGE_CONTENT_DOCUMENT_TYPE || (exports.MESSAGE_CONTENT_DOCUMENT_TYPE = MESSAGE_CONTENT_DOCUMENT_TYPE = {}));
var MESSAGE_STATUS;
(function (MESSAGE_STATUS) {
    MESSAGE_STATUS["ACTIVE"] = "ACTIVE";
    MESSAGE_STATUS["PENDING"] = "PENDING";
    MESSAGE_STATUS["DELETED"] = "DELETED";
    MESSAGE_STATUS["EDITED"] = "EDITED";
    MESSAGE_STATUS["FAILED"] = "FAILED";
})(MESSAGE_STATUS || (exports.MESSAGE_STATUS = MESSAGE_STATUS = {}));
var EDIT_MESSAGE_STATUS;
(function (EDIT_MESSAGE_STATUS) {
    EDIT_MESSAGE_STATUS["PENDING"] = "PENDING";
    EDIT_MESSAGE_STATUS["FAILED"] = "FAILED";
})(EDIT_MESSAGE_STATUS || (exports.EDIT_MESSAGE_STATUS = EDIT_MESSAGE_STATUS = {}));
exports.FILE_CONSTANTS = {
    FILE_SIZE_LIMIT_BYTES: 100 * 1024 * 1024,
};
exports.UPLOAD_CONFIG = {
    web: {
        BULK_UPLOAD_CONFIRM_THRESHOLD: 10,
        MAX_TOTAL_UPLOAD_SIZE_BYTES: 500 * 1024 * 1024,
    },
    mobile: {
        BULK_UPLOAD_CONFIRM_THRESHOLD: 5,
        MAX_TOTAL_UPLOAD_SIZE_BYTES: 200 * 1024 * 1024,
    },
};
exports.ACCEPTED_FILE_TYPES_WITHOUT_AUDIO_VIDEO = {
    "image/png": [],
    "image/jpeg": [],
    "application/pdf": [],
    "application/vnd.ms-excel": [],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
    "application/msword": [],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
};
exports.ACCEPTED_FILE_TYPES = Object.assign(Object.assign({}, exports.ACCEPTED_FILE_TYPES_WITHOUT_AUDIO_VIDEO), { "audio/wav": [], "audio/x-m4a": [], "audio/m4a": [], "audio/mpeg": [], "video/mp4": [] });
var FILE_TYPE;
(function (FILE_TYPE) {
    FILE_TYPE["IMAGE"] = "IMAGE";
    FILE_TYPE["AUDIO"] = "AUDIO";
    FILE_TYPE["VIDEO"] = "VIDEO";
    FILE_TYPE["DOC"] = "DOC";
})(FILE_TYPE || (exports.FILE_TYPE = FILE_TYPE = {}));
exports.SOCKET_BODY_EMOJI = {
    REMINDER: "📆 Reminder",
    LOCATION: "📍 Location",
    AUDIO: "🎙 Audio",
    VIDEO: "🎬 Video",
    DOCUMENT: "📄 Document",
    IMAGE: "📷 Image",
    FORM: "📝",
    CALLING: "📞",
    BLOCKED: `🚫`,
};
var REMINDER_TYPE;
(function (REMINDER_TYPE) {
    REMINDER_TYPE["SYS_TEMPLATE_REMINDER"] = "SYS_TEMPLATE_REMINDER";
    REMINDER_TYPE["SYS_REFERRAL_REMINDER"] = "SYS_REFERRAL_REMINDER";
})(REMINDER_TYPE || (exports.REMINDER_TYPE = REMINDER_TYPE = {}));
